import React, { useState, useEffect, useRef } from "react";
import "./style/CustomSliderSwitch.css";

export default function CustomSliderSwitch({
  options = [],
  initialIndex = 0, 
  onChange = () => {}, 
  transitionDuration = 300
}) {
  const [activeIndex, setActiveIndex] = useState(initialIndex);
  const [isAnimating, setIsAnimating] = useState(false);
  const sliderRef = useRef(null);
  const wrapperRef = useRef(null);

  const updateSliderPosition = (index) => {
    if (!sliderRef.current || !wrapperRef.current) return;

    const wrapperWidth = wrapperRef.current.offsetWidth;
    const gap = 4 * 2;
    const sliderWidth = wrapperWidth / options.length - gap;

    sliderRef.current.style.width = `${sliderWidth}px`;
    sliderRef.current.style.left = `${index * sliderWidth + index * gap}px`;
  };

  useEffect(() => {
    updateSliderPosition(activeIndex);
  }, [activeIndex, options]);

  const handleClick = (index) => {
    if (index === activeIndex) return;

    setIsAnimating(true);
    setActiveIndex(index);
    onChange(index);

    setTimeout(() => setIsAnimating(false), transitionDuration);
  };

  return (
    <div className="slider-switch-wrapper" ref={wrapperRef}>
      {options.map((option, index) => (
        <div
          key={index}
          className={`slider-switch-indicator ${activeIndex === index ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          {option.icon && (
            <img src={option.icon} alt={option.label} className="slider-switch-icon" />
          )}
          <span className="slider-switch-title">{option.label}</span>
        </div>
      ))}
      <div
        className={`slider-switch-slider ${isAnimating ? "active" : ""}`}
        ref={sliderRef}
      ></div>
    </div>
  );
}
